import React from 'react';
import { ArrowLeft, Phone, MessageCircle } from 'lucide-react';

const MenuHeader = ({ 
  businessName = "Mr. Frogs", 
  showBackButton = false,
  onBack,
  rightContent,
  phoneNumber,
  whatsappNumber
}) => {
  const handleWhatsApp = () => {
    if (whatsappNumber) {
      // Clean the number and open WhatsApp
      const cleanNumber = whatsappNumber.replace(/\D/g, '');
      window.open(`https://wa.me/${cleanNumber}`, '_blank');
    }
  };

  const handleCall = () => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    }
  };

  return (
    <header 
      className="sticky top-0 z-40 bg-slate-950/85 backdrop-blur-md border-b border-white/10 px-4 py-3"
      data-testid="menu-header"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Left side */}
        <div className="flex items-center gap-3">
          {showBackButton ? (
            <button
              onClick={onBack}
              className="p-2 hover:bg-white/10 rounded-full transition-colors"
              data-testid="back-btn"
            >
              <ArrowLeft className="w-5 h-5 text-white" />
            </button>
          ) : null}
          
          {/* Logo/Brand */}
          <div className="flex items-center gap-2">
            <span className="text-2xl">🐸</span>
            <h1 className="text-lg sm:text-xl font-bold text-white tracking-tight">
              {businessName}
            </h1>
          </div>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-2">
          {rightContent}
          
          {/* WhatsApp Button */}
          {whatsappNumber && (
            <button
              onClick={handleWhatsApp}
              className="flex items-center gap-2 px-3 py-2 bg-green-600 hover:bg-green-500 text-white rounded-full text-sm font-medium transition-all"
              data-testid="whatsapp-btn"
              title="WhatsApp"
            >
              <MessageCircle className="w-4 h-4" />
              <span className="hidden sm:inline">WhatsApp</span>
            </button>
          )}
          
          {/* Phone Button */}
          {phoneNumber && (
            <button
              onClick={handleCall}
              className="flex items-center gap-2 px-3 py-2 bg-slate-800/80 hover:bg-slate-700 text-slate-300 hover:text-white rounded-full text-sm font-medium transition-all border border-white/10 hover:border-white/20"
              data-testid="phone-btn"
              title="Llamar"
            >
              <Phone className="w-4 h-4" />
              <span className="hidden sm:inline">Llamar</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default MenuHeader;
